"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modules = exports.formats = exports["default"] = exports.QuillToolbar = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactQuill = require("react-quill");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var CustomUndo = function CustomUndo() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/_react["default"].createElement("polygon", {
    className: "ql-fill ql-stroke",
    points: "6 10 4 12 2 10 6 10"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "ql-stroke",
    d: "M8.09,13.91A4.6,4.6,0,0,0,9,14,5,5,0,1,0,4,9"
  }));
};

// Redo button icon component for Quill editor
var CustomRedo = function CustomRedo() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/_react["default"].createElement("polygon", {
    className: "ql-fill ql-stroke",
    points: "12 10 14 12 16 10 12 10"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "ql-stroke",
    d: "M9.91,13.91A4.6,4.6,0,0,1,9,14a5,5,0,1,1,5-5"
  }));
};

// Undo and redo functions for Custom Toolbar
function undoChange() {
  this.quill.history.undo();
}
function redoChange() {
  this.quill.history.redo();
}

// Add sizes to whitelist and register them
var Size = _reactQuill.Quill["import"]("formats/size");
Size.whitelist = ["extra-small", "small", "medium", "large"];
_reactQuill.Quill.register(Size, true);

// Add fonts to whitelist and register them
var Font = _reactQuill.Quill["import"]("formats/font");
Font.whitelist = ["serif", "comic-sans", "courier-new", "georgia", "helvetica", "lucida"];
_reactQuill.Quill.register(Font, true);

// Modules object for setting up the Quill editor
var modules = {
  toolbar: {
    container: "#toolbar",
    handlers: {
      undo: undoChange,
      redo: redoChange
    }
  },
  history: {
    delay: 500,
    maxStack: 100,
    userOnly: true
  }
};

// Formats objects for setting up the Quill editor
exports.modules = modules;
var formats = ["header", "font", "size", "bold", "italic", "underline", "align", "strike", "script", "blockquote", "background", "list", "bullet", "indent", "link", "image", "color", "code-block"];
exports.formats = formats;
var QuillToolbar = function QuillToolbar() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "toolbar"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "ql-formats"
  }, /*#__PURE__*/_react["default"].createElement("select", {
    className: "ql-font",
    defaultValue: "arial"
  }, /*#__PURE__*/_react["default"].createElement("option", {
    value: "serif"
  }, "serif"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "sans-serif"
  }, "sans-serif"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "monospace"
  }, "Monospace"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "cursive"
  }, "Cursive"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "fantasy"
  }, "Fantasy")), /*#__PURE__*/_react["default"].createElement("select", {
    className: "ql-header",
    defaultValue: "medium"
  }, /*#__PURE__*/_react["default"].createElement("option", {
    value: "1"
  }, "Heading 1"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "2"
  }, "Heading 2"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "3"
  }, "Heading 3"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "4"
  }, "Heading 4"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "5"
  }, "Heading 5"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "6"
  }, "Heading 6"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "p"
  }, "Paragraph"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "pre"
  }, "Preformatted"))), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ql-formats"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "ql-bold"
  }), /*#__PURE__*/_react["default"].createElement("button", {
    className: "ql-italic"
  }), /*#__PURE__*/_react["default"].createElement("button", {
    className: "ql-underline"
  }), /*#__PURE__*/_react["default"].createElement("button", {
    className: "ql-strike"
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ql-formats"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "ql-list",
    value: "ordered"
  }), /*#__PURE__*/_react["default"].createElement("button", {
    className: "ql-list",
    value: "bullet"
  }), /*#__PURE__*/_react["default"].createElement("button", {
    className: "ql-indent",
    value: "-1"
  }), /*#__PURE__*/_react["default"].createElement("button", {
    className: "ql-indent",
    value: "+1"
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ql-formats"
  }, /*#__PURE__*/_react["default"].createElement("select", {
    className: "ql-align"
  }), /*#__PURE__*/_react["default"].createElement("select", {
    className: "ql-color"
  }), /*#__PURE__*/_react["default"].createElement("select", {
    className: "ql-background"
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ql-formats"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "ql-link"
  }), /*#__PURE__*/_react["default"].createElement("button", {
    className: "ql-image"
  }), /*#__PURE__*/_react["default"].createElement("button", {
    className: "ql-video"
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ql-formats"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "ql-code-block"
  })));
};
exports.QuillToolbar = QuillToolbar;
var _default = QuillToolbar;
exports["default"] = _default;